import axios from 'axios'
import * as types from '@store/types'
import store from '@store'

const search = async (options) => {
  const { slug } = store.getters[types.CAMPAIGN]
  const params = {
    index: 'addresses',
    filters: 'campaigns: ' + slug,
    page: 0,
    hitsPerPage: 10,
    ...options,
  }
  return await axios.post('/search/', params)
}

const state = {
  results: [],
  params: {
    query: '',
    page: 0,
    total: 0
  }
}

const getters = {
  [types.ADDRESS]: ({ results }) => results,
  [types.ADDRESS_PAGINATE]: ({ results, params: { total } }) =>
    results && (results.length < total),
  [types.ADDRESS_QUERY]: ({ params: { query } }) => query,
  [types.ADDRESS_PARAMS]: ({ params }) => params
}

const mutations = {
  [types.ADDRESS]: (state, payload) => {
    state.results = payload
  },
  [types.ADDRESS_PARAMS]: (state, payload) => {
    state.params = { ...state.params, ...payload }
  }
}

const actions = {
  [types.ADDRESS]: async ({ commit }, query) => {
    const { data: { hits: results, page, nbHits: total } } = await search({ query })

    commit(types.ADDRESS, results)
    commit(types.ADDRESS_PARAMS, { page, total, query })
  },
  [types.ADDRESS_PAGINATE]: async ({ getters, commit }) => {
    const addresses = getters[types.ADDRESS]
    const params = {
      ...getters[types.ADDRESS_PARAMS],
      page: getters[types.ADDRESS_PARAMS].page + 1
    }

    const { data: { hits: results, nbHits: total } } = await search(params)

    commit(types.ADDRESS, [ ...addresses, ...results ])
    commit(types.ADDRESS_PARAMS, params)
  }
}

export default { state, getters, mutations, actions }



// WEBPACK FOOTER //
// ./src/store/modules/address.js